import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Actions
import {
  fetchExportStudyPDF,
  toggleExportPdfDialog,
  setVirtualKeyboard,
} from "../../actions";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputBase from "@material-ui/core/InputBase";
import FormControl from "@material-ui/core/FormControl";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";

// Icons
import FolderIcon from "@material-ui/icons/Folder";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

// Other Files
import { customTheme } from "../../constants/customTheme";
import { colors } from "../../constants/colors";
import { wipFolder } from "../../constants/constants";
import classNames from "classnames";
import VirtualKeyboard from "../Shared/VirtualKeyboard";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  buttonContainer: customTheme().dialog.buttonContainer,
  title: customTheme().dialog.title,
  contentContainer: (props) => ({
    ...customTheme().dialog.contentContainer,
    ...customTheme(props.theme).customScrollBar,
    overflowY: "auto",
  }),
  contentItem: customTheme().dialog.contentItem,
  contentItemPDF: {
    marginLeft: "10px",
    marginRight: "10px",
    marginBottom: "15px",
    paddingLeft: "40px",
    "& .MuiInputLabel-root": {
      paddingLeft: "40px",
    },
  },
  muiAccordion: {
    boxShadow: "unset",
    backgroundColor: (props) => colors[props.theme].dialogBkg,
    margin: "0px",
    position: "unset",
    overflow: "hidden",
    padding: "0px",
    "& .MuiMuiAccordion-root:before": {
      backgroundColor: "unset",
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0px",
    },
    "& .MuiMuiAccordionSummary-root": {
      padding: "0px",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "0px",
    },
    "& .MuiAccordionSummary-content": {
      margin: "0px",
    },
  },
  muiAccordionDetails: {
    minHeight: "auto",
    height: "auto",
  },
  buttonOutlined: (props) => ({
    width: "110px",
    ...customTheme(props.theme).buttonOutlined,
  }),
  buttonExport: (props) => ({
    width: "170px",
    minHeight: "36.5px",
    ...customTheme(props.theme).buttonPrimary,
  }),
  formText: customTheme().formText,
  fileIcon: (props) => customTheme(props.theme).iconButton,

  contentItemPadding: customTheme().dialog.contentItemPadding,
  muiAccordionSummary: {
    padding: "0px 9px",
  },
  progressCircle: {
    marginRight: "15px",
    color: "rgba(255,255,255,1)",
  },
  progressLabel: {
    fontSize: "0.9rem",
  },
});

const ExportPdfDialog = (props) => {
  const classes = useStyles(props);
  const getInitialFilepath = () => {
    if (props.studySaved) {
      return props.initialPath;
    } else {
      // If study hasnt been saved before, then the default PDF save locatin is the Work In Progress folder
      let pathArray = props.initialPath.split("/");
      let initialPath =
        pathArray.splice(0, pathArray.length - 1).join("/") + "/" + wipFolder;
      return initialPath;
    }
  };

  // useEffect(() => {
  //   props.eventSource.addEventListener("progress_indicator", handleEvent);
  //   return () => {
  //     props.eventSource.removeEventListener("progress_indicator", handleEvent);
  //   };
  // }, []);

  const handleEvent = (e) => {
    switch (e.type) {
      case "progress_indicator":
        setProgressIndicator(JSON.parse(e.data) * 100);
        break;
      default:
    }
  };

  const [localState, setLocalState] = React.useState({
    pdfPassword: {
      state: true,
      password: "",
    },
    showPassword: false,
    fileName: props.studyId,
    filePath: getInitialFilepath(),
  });

  const [keyboardInput, setKeyboardInput] = React.useState({
    inputName: null,
    inputUpdate: { pdfPassword: "", fileName: "" },
  });
  // Circular progress value
  const [progressIndicator, setProgressIndicator] = React.useState(0);

  const handleExportPDF = () => {
    let password = null;
    if (
      localState.pdfPassword.state === true &&
      localState.pdfPassword.password !== ""
    ) {
      password = localState.pdfPassword.password;
    }
    props.setVirtualKeyboard(false);
    props.fetchExportStudyPDF(
      password,
      localState.filePath + "/" + localState.fileName + ".pdf"
    );
  };

  const handleFileExplorer = () => {
    // const { dialog } = window.require("electron").remote;
    // const defaultPath = localState.filePath.split("/").join("\\");
    // dialog.showOpenDialog(
    //   {
    //     defaultPath: defaultPath,
    //     properties: ["openDirectory"],
    //   },
    //   (filePaths) => {
    //     if (filePaths !== undefined && filePaths.length !== 0) {
    //       let newPath = filePaths[0].split("\\").join("/");
    //       setLocalState({ ...localState, filePath: newPath });
    //     }
    //   }
    // );
  };

  const handleTextFieldChange = () => (event) => {
    setLocalState({ ...localState, fileName: event.target.value });
    setKeyboardInput({
      ...keyboardInput,
      inputUpdate: {
        ...keyboardInput.inputUpdate,
        fileName: event.target.value,
      },
    });
  };

  return (
    <Dialog
      open={props.open}
      onExiting={() => props.setVirtualKeyboard(false)}
      PaperProps={{ className: classNames(classes.root) }}
      disableBackdropClick={true}
    >
      <Typography
        className={classes.title}
        variant="h4"
        color="textPrimary"
        align="center"
      >
        Export Study as PDF
      </Typography>

      <DialogContent className={classes.contentContainer}>
        <FormControlLabel
          className={classes.contentItem}
          control={
            <Checkbox
              color="primary"
              checked={localState.pdfPassword.state}
              onChange={() =>
                setLocalState({
                  ...localState,
                  pdfPassword: {
                    ...localState.pdfPassword,
                    state: !localState.pdfPassword.state,
                  },
                })
              }
            />
          }
          label="Add password protection to PDF"
        />
        <Collapse
          style={{
            minHeight: "auto",
            height: "auto",
          }}
          in={localState.pdfPassword.state}
        >
          <TextField
            required
            className={classes.contentItemPDF}
            label="PDF Password"
            type={localState.showPassword ? "text" : "password"}
            value={localState.pdfPassword.password}
            onFocus={() => {
              setKeyboardInput({
                ...keyboardInput,
                inputName: "pdfPassword",
              });
              props.setVirtualKeyboard(true);
            }}
            onChange={(event) => {
              setLocalState({
                ...localState,
                pdfPassword: {
                  ...localState.pdfPassword,
                  password: event.target.value,
                },
              });
              setKeyboardInput({
                ...keyboardInput,
                inputUpdate: {
                  ...keyboardInput.inputUpdate,
                  pdfPassword: event.target.value,
                },
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setLocalState({
                        ...localState,
                        showPassword: !localState.showPassword,
                      })
                    }
                  >
                    {localState.showPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Collapse>

        <InputBase
          className={classes.contentItemPadding}
          value={localState.filePath}
          fullWidth
          multiline
          rowsMax={2}
          readOnly
          startAdornment={
            <InputAdornment position="start">
              <IconButton
                className={classes.fileIcon}
                onClick={handleFileExplorer}
              >
                <FolderIcon />
              </IconButton>
            </InputAdornment>
          }
          inputProps={{
            className: classes.formText,
          }}
        />

        <FormControl
          onFocus={() => {
            setKeyboardInput({
              ...keyboardInput,
              inputName: "fileName",
            });
            props.setVirtualKeyboard(true);
          }}
          className={classes.contentItemPadding}
          fullWidth
        >
          <Input
            value={localState.fileName}
            onChange={handleTextFieldChange()}
            endAdornment={<InputAdornment position="end">.pdf</InputAdornment>}
            inputProps={{
              className: classes.formItem,
            }}
          />
          <FormHelperText>File Name</FormHelperText>
        </FormControl>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <Button
          disabled={props.requestExportPdf}
          onClick={() => props.onClose()}
          className={classes.buttonOutlined}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleExportPDF()}
          className={classes.buttonExport}
          variant="contained"
          color="primary"
          disabled={
            (localState.pdfPassword.state &&
              localState.pdfPassword.password.length === 0) ||
            props.requestExportPdf
          }
        >
          {props.requestExportPdf ? (
            <Box
              className={classes.progressCircle}
              position="relative"
              display="inline-flex"
            >
              <CircularProgress
                size={38}
                variant="static"
                value={progressIndicator}
              />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  className={classes.progressLabel}
                  variant="caption"
                  component="div"
                >{`${Math.round(progressIndicator)}%`}</Typography>
              </Box>
            </Box>
          ) : (
            "Export PDF"
          )}
        </Button>
      </DialogActions>
      <VirtualKeyboard
        anchor={"center"}
        keyboardInitialInput={{
          fileName: localState.fileName,
          pdfPassword: localState.pdfPassword.password,
        }}
        keyboardInputUpdate={keyboardInput.inputUpdate}
        keyboardInputName={keyboardInput.inputName}
        keyboardChange={(event) =>
          setLocalState({
            ...localState,
            pdfPassword: {
              ...localState.pdfPassword,
              password: event,
            },
          })
        }
      />
    </Dialog>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleExportPdfDialog,
      fetchExportStudyPDF,
      setVirtualKeyboard,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    studySaved: state.studyInfo.studySaved,
    studyId: state.studyInfo.id,
    requestExportPdf: state.utility.requestExportPdf,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportPdfDialog);
